import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ number, eyebrow, title, description, dark = false }) => (
  <div className="mb-16 max-w-3xl md:mb-24">
    <Reveal>
      <div className="mb-6 flex items-center gap-4">
        <span className={`font-jakarta text-sm font-bold tracking-[0.3em] ${dark ? "text-gold" : "text-royal/60"}`}>
          {number}
        </span>
        <span className={`h-px w-16 ${dark ? "bg-gold/60" : "bg-royal/30"}`} />
        <span className={`font-jakarta text-xs font-semibold uppercase tracking-[0.3em] ${dark ? "text-sky" : "text-royal/60"}`}>
          {eyebrow}
        </span>
      </div>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className={`font-jakarta text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl ${dark ? "text-white" : "text-navy"}`}>
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.2}>
        <p className={`mt-6 max-w-xl text-base leading-relaxed md:text-lg ${dark ? "text-white/60" : "text-royal/70"}`}>
          {description}
        </p>
      </Reveal>
    )}
  </div>
);
